// Layout constants
export const DRAWER_WIDTH = 240;
export const DEFAULT_DRAWER_WIDTH = 240;
export const MIN_DRAWER_WIDTH = 180;
export const MAX_DRAWER_WIDTH = 400;
export const COLLAPSED_DRAWER_WIDTH = 64;

// Navigation colors - all using the same blue shade as Patients
export const NAVIGATION_COLORS = {
  '/dashboard': '#1976d2',
  '/patients': '#1976d2', 
  '/encounters': '#1976d2',
  '/documents': '#1976d2',
  '/settings': '#1976d2',
  'Admin': '#1976d2',
  'Inpatient': '#1976d2',
  'Procedures': '#1976d2',
  'Revenue Management': '#1976d2',
};

// Path labels mapping
export const PATH_LABELS = {
  // Main sections
  '/dashboard': 'Dashboard',
  '/patients': 'Patients',
  '/appointments': 'Appointments',
  '/calendar': 'Calendar',
  '/billing': 'Billing',
  '/encounters': 'Encounters',
  '/prescriptions': 'Prescriptions',
  '/messaging': 'Messaging',
  '/bi-reporting': 'BI Reporting',
  '/bi-reporting/compliance': 'Compliance and Metrics',
  '/carecoordination': 'Care Coordination',
  '/my-account': 'My Account',
  
  // Revenue Management
  '/revenue/dashboard': 'Revenue',
  '/revenue/surgery-dashboard': 'Surgery Revenue',
  
  // Inpatient
  '/inpatient/list': 'Census',
  '/inpatient/admit': 'Admit',
  '/inpatient/discharge': 'Discharge',
  '/inpatient/transfer': 'Transfer',
  '/inpatient/bed-assignment': 'Bed Assignment',
  '/inpatient/flowsheet': 'Flowsheet',
  
  // Emergency
  '/triage-board': 'Triage',
  '/emergency/triage': 'Triage',
  '/emergency/dashboard': 'ED Dashboard',
  
  // Procedures/Labs
  '/procedures': 'Lab Orders',
  '/procedures/test-panels': 'Test Panels',
  '/procedures/test-definitions': 'Test Definitions',
  '/procedures/results': 'Lab Results',
  '/procedures/order-status': 'Order Status',
  
  // Surgical
  '/surgical-facilities': 'Surgery',
  '/surgical-facilities/schedule': 'OR Schedule',
  '/surgical-facilities/cases': 'Cases',
  '/surgical-facilities/equipment': 'Equipment',
  
  // Facilities
  '/facilities': 'Facilities',
  '/facilities/departments': 'Departments',
  '/facilities/rooms': 'Rooms',
  '/facilities/beds': 'Beds',
  
  // Dynamic paths
  '/patients/': 'Patient',
  '/encounters/': 'Encounter',
  '/appointments/': 'Appointment',
  '/prescriptions/': 'Prescription',
  '/billing/': 'Bill',
  '/procedures/': 'Procedure'
};

// Clock-in allowed paths
export const ALLOWED_PATHS_WHEN_NOT_CLOCKED_IN = ['/dashboard', '/my-account']; 